import { render, staticRenderFns } from "./PreflightsPage.vue?vue&type=template&id=fa60f78e&scoped=true&"
import script from "./PreflightsPage.vue?vue&type=script&lang=js&"
export * from "./PreflightsPage.vue?vue&type=script&lang=js&"
import style0 from "./PreflightsPage.vue?vue&type=style&index=0&id=fa60f78e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa60f78e",
  null
  
)

export default component.exports